import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// components
import { LoginComponent } from '../login/login.component';

// NGRX related
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducers } from './store/reducers';
import { AuthEffects } from './store/effects/auth.effects';

// provided services
import { AuthService } from './auth.service';
import { AuthenticatedUserService, IsAdminService, NotAuthenticatedService } from './auth-guard.service';

// routing
import { AuthRoutingModule } from './auth-routing.module';

@NgModule({
  imports: [CommonModule, AuthRoutingModule, StoreModule.forFeature('auth', reducers), EffectsModule.forFeature([AuthEffects])],
  providers: [AuthService, AuthenticatedUserService, IsAdminService, NotAuthenticatedService],
  declarations: [LoginComponent]
})
export class AuthModule {}
